import React, {Component, ReactElement, ReactNode} from 'react'
import {Nullable} from '../../../../app/TypeHelpers'
import {ReservationOption, ReserveFacilityModel} from '../../../../components/reservations/ReserveFacilityModel'
import {
    ACCESS_CONTROL_MANAGER,
    CASH_PAYMENT_STATUS,
    FACILITY_RESERVATION_CLASSIFICATION,
    HOURS,
    PAYMENT_TYPE,
    RESERVATION_STATUS,
    RESERVATION_TIME_UNIT_MINUTES,
    RESERVATION_TYPE,
    SELECT_USER_TYPE,
} from '../../../../CodeMaster'
import {ConditionTableFixed} from '../../../../styledComponents/adminPage/ConditionTable'
import {StyledTableCaption, TableRowName} from '../../../../styledComponents/adminPage/Table'
import {LeftRowFlexContainer, RowFlexContainer} from '../../../../styledComponents/FlexComponents'
import PPSelect, {OptionProps} from '../../../../components/shared/forms/PPSelect'
import styled from 'styled-components'
import {StyledDiv, StyledLabel, StyledSpan} from '../../../../styledComponents/StyledTypeDefinitions'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import PPRadioGroup, {PPRadioItemProp} from '../../../../components/shared/forms/PPRadioGroup'
import PPTextField from '../../../../components/shared/forms/PPTextField'
import PPErrorDisplayButton from '../../../../components/shared/forms/PPErrorDisplayButton'
import {Messages} from '../../../../Messages'
import {HKConstants} from '../../../../HKConstants'
import NatResidentUserSelectionComponent from '../../common/admin/NatResidentUserSelectionComponent'
import {DeleteLink} from '../../../../styledComponents/adminPage/Links'
import FacilityForReservation from '../../../../components/facilities/FacilityForReservation'
import PPDatePicker from '../../../../components/shared/forms/PPDatePicker'
import {SelectedUserList} from '../repository/NatGetFacilityReserve'
import NatRoomToResidentRepo from '../../roomToResident/repository/NatRoomToResidentRepo'
import NatRidgeRepo from '../../ridge/repository/NatRidgeRepo'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {AsyncCommunicationProps} from '../../../../components/shared/hoc/withAsyncCommunication'
import {NatAdminFacilityReserveInfo} from './NatAdminFacilityReserve'
import {formatForDateInput} from '../../../../formatters/formatDate'
import {getHourLabel, getMinutsLabel} from '../../../common/util/Natutil'
import {ExcudeResidentUserInfo} from '../../roomToResident/repository/NatGetRoomToResident'
import {calculateReservationType} from '../../../../components/reservations/reservationTypeCalculator'
import moment from 'moment'

import {TableBody, TableCell, TableRow} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'
import {Location, NavigateFunction} from 'react-router-dom'

const SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'

interface Props {
    facilityData: FacilityForReservation
    facilityReserveEditInfo: NatAdminFacilityReserveInfo
    holidays: Nullable<string[]>
    reservationOptions: ReservationOption[]
    RoomToResidentRepo: NatRoomToResidentRepo
    RidgeRepo: NatRidgeRepo
    reservationModel: ReserveFacilityModel
    excudeResidentUserInfo: Nullable<ExcudeResidentUserInfo>
    currentDateTime: Nullable<moment.Moment>
    eventEmitter: EventEmitterExAdmin
    navigate: NavigateFunction,
    location: Location,
    onChangeFacilityReserveInfo: (facilityReserveEditInfo: NatAdminFacilityReserveInfo) => void
}

interface States {
    facilityReserveEditInfo: NatAdminFacilityReserveInfo
    reservationOptions: ReservationOption[]
    dialogOpenSelectResidentUser: boolean
    selectedCondominiumCd: string
}

class NatAdminFacilityReserveInfoComponent extends Component<Props & AsyncCommunicationProps, States> {
    constructor(props: Props & AsyncCommunicationProps) {
        super(props)

        const selectedCondominiumCd: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(SELECTED_CONDOMINIUM_CD)

        this.state = {
            reservationOptions: props.reservationOptions,
            facilityReserveEditInfo: props.facilityReserveEditInfo,
            dialogOpenSelectResidentUser: false,
            selectedCondominiumCd: String(selectedCondominiumCd),
        }

        this.handleOpenResidentUserSelectionDialog = this.handleOpenResidentUserSelectionDialog.bind(this)
        this.closeSelectResidentUserDiaLog = this.closeSelectResidentUserDiaLog.bind(this)
        this.setSelectedResidentUserInfo = this.setSelectedResidentUserInfo.bind(this)
        this.delSelectedUserInfo = this.delSelectedUserInfo.bind(this)
        this.onChangeReserveTitle = this.onChangeReserveTitle.bind(this)
        this.onChangePaymentMethod = this.onChangePaymentMethod.bind(this)
        this.onChangeCashPaymentStatus = this.onChangeCashPaymentStatus.bind(this)
        this.onChangeOvernightStartDate = this.onChangeOvernightStartDate.bind(this)
        this.onChangeDurationStartDate = this.onChangeDurationStartDate.bind(this)
        this.onChangeDurationStartDateHour = this.onChangeDurationStartDateHour.bind(this)
        this.onChangeDurationStartDateMinute = this.onChangeDurationStartDateMinute.bind(this)
        this.onChangeDurationEndDate = this.onChangeDurationEndDate.bind(this)
        this.onChangeDurationEndDateHour = this.onChangeDurationEndDateHour.bind(this)
        this.onChangeDurationEndDateMinute = this.onChangeDurationEndDateMinute.bind(this)
        this.onChangeStayCount = this.onChangeStayCount.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const {facilityData} = this.props

        this.updateSelectedUserList()

        if (facilityData.stayAvailability !== null && facilityData.stayAvailability) {
            this.updateStayModel()
        } else {
            this.updateTimeModel()
        }
    }

    updateTimeModel(): void {
        const {reservationModel} = this.props
        const {facilityReserveEditInfo} = this.state

        if (facilityReserveEditInfo.startDate === '') {
            return
        }

        const endDate: Nullable<string> =
            (facilityReserveEditInfo.endDate === '') ? null : formatForDateInput(facilityReserveEditInfo.endDate)

        reservationModel.withDurationReservationData(
            formatForDateInput(facilityReserveEditInfo.startDate),
            `${('0' + getHourLabel(facilityReserveEditInfo.startTimeHour)).slice(-2)}:${('0' + getMinutsLabel(facilityReserveEditInfo.startTimeMinute)).slice(-2)}`,
            endDate,
            `${('0' + getHourLabel(facilityReserveEditInfo.endTimeHour)).slice(-2)}:${('0' + getMinutsLabel(facilityReserveEditInfo.endTimeMinute)).slice(-2)}`,
        )
    }

    updateStayModel(): void {
        const {reservationModel} = this.props
        const {facilityReserveEditInfo} = this.state

        reservationModel.withOvernightReservationData(
            facilityReserveEditInfo.startDate, Number(facilityReserveEditInfo.stayCount))
    }

    updateSelectedUserList(): void {
        const {reservationModel} = this.props
        const {facilityReserveEditInfo} = this.state

        if (facilityReserveEditInfo.selectedUserList !== null) {
            reservationModel.withSelectedUserList(facilityReserveEditInfo.selectedUserList)
        }
    }

    updateModel(): void {
        const {facilityData} = this.props

        if (facilityData.stayAvailability !== null && facilityData.stayAvailability) {
            this.updateStayModel()
        } else {
            this.updateTimeModel()
        }
    }

    onChangeReserveTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.reserveTitle = event.target.value

        this.setState({facilityReserveEditInfo: facilityReserveEditInfo})
        this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
        this.props.reservationModel.withReservationTitle(event.target.value)
    }

    onChangePaymentMethod(event: SelectChangeEvent<unknown>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.facilityPaymentMethod = event.target.value as string

        if (facilityReserveEditInfo.facilityPaymentMethod === PAYMENT_TYPE.CASH.value) {
            facilityReserveEditInfo.cashPaymentStatus = CASH_PAYMENT_STATUS.YET_PAID.value
        }

        this.setState({facilityReserveEditInfo: facilityReserveEditInfo})
        this.updateModel()
        this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
    }


    onChangeCashPaymentStatus(event: React.ChangeEvent<HTMLInputElement>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.cashPaymentStatus = event.target.value

        this.setState({facilityReserveEditInfo: facilityReserveEditInfo})
        this.updateModel()
        this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
    }

    onChangeOvernightStartDate(date: Nullable<Date>): void {
        const {currentDateTime} = this.props
        const {lotteryAvailability, lotterySetting} = this.props.facilityData
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        if (currentDateTime === null) {
            return
        }
        if (date !== null) {
            facilityReserveEditInfo.startDate = formatForDateInput(date.toString())

            const endDate = new Date(date.toString())
            endDate.setDate(endDate.getDate() + Number(facilityReserveEditInfo.stayCount))
            facilityReserveEditInfo.endDate = formatForDateInput(endDate.toString())

            if (facilityReserveEditInfo.facilityReserveCategory !== FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value) {
                let reservationType: Nullable<RESERVATION_TYPE> =
                    calculateReservationType(
                        moment(facilityReserveEditInfo.startDate),
                        currentDateTime,
                        lotteryAvailability,
                        lotterySetting,
                    )
                if (reservationType === null) {
                    reservationType = RESERVATION_TYPE.FIRST_COME
                }
                facilityReserveEditInfo.reserveType = reservationType.value
            } else {
                facilityReserveEditInfo.reserveType = RESERVATION_TYPE.FIRST_COME.value
            }
            this.setState({facilityReserveEditInfo: facilityReserveEditInfo},
                () => {
                    this.updateStayModel()
                })
            this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
        } else {
            facilityReserveEditInfo.startDate = ''
            this.setState({facilityReserveEditInfo: facilityReserveEditInfo})
            this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
        }
    }

    onChangeDurationStartDate(date: Nullable<Date>): void {
        const {currentDateTime} = this.props
        const {lotteryAvailability, lotterySetting} = this.props.facilityData
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo

        if (currentDateTime === null) {
            return
        }
        if (date !== null) {
            facilityReserveEditInfo.startDate = formatForDateInput(date.toString())
            facilityReserveEditInfo.endMinDate = formatForDateInput(date.toString())

            if (facilityReserveEditInfo.facilityReserveCategory !== FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value) {
                let reservationType: Nullable<RESERVATION_TYPE> =
                    calculateReservationType(
                        moment(facilityReserveEditInfo.startDate),
                        currentDateTime,
                        lotteryAvailability,
                        lotterySetting,
                    )
                if (reservationType === null) {
                    reservationType = RESERVATION_TYPE.FIRST_COME
                }
                facilityReserveEditInfo.reserveType = reservationType.value
            } else {
                facilityReserveEditInfo.reserveType = RESERVATION_TYPE.FIRST_COME.value
            }

            this.setState({facilityReserveEditInfo: facilityReserveEditInfo},
                () => {
                    this.updateTimeModel()
                })
            this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
        } else {
            facilityReserveEditInfo.startDate = ''
            this.setState({facilityReserveEditInfo: facilityReserveEditInfo})
            this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
        }
    }

    onChangeDurationStartDateHour(event: SelectChangeEvent<unknown>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.startTimeHour = event.target.value as string

        this.setState({facilityReserveEditInfo: facilityReserveEditInfo},
            () => {
                this.updateTimeModel()
            })
        this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
    }

    onChangeDurationStartDateMinute(event: SelectChangeEvent<unknown>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.startTimeMinute = event.target.value as string

        this.setState({facilityReserveEditInfo: facilityReserveEditInfo},
            () => {
                this.updateTimeModel()
            })
        this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
    }

    onChangeDurationEndDate(date: Nullable<Date>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        if (date !== null) {
            facilityReserveEditInfo.endDate = formatForDateInput(date.toString())
            facilityReserveEditInfo.startMaxDate = formatForDateInput(date.toString())

            this.setState({facilityReserveEditInfo: facilityReserveEditInfo},
                () => {
                    this.updateTimeModel()
                })
            this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
        } else {
            facilityReserveEditInfo.endDate = ''
            this.setState({facilityReserveEditInfo: facilityReserveEditInfo})
            this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
        }
    }

    onChangeDurationEndDateHour(event: SelectChangeEvent<unknown>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.endTimeHour = event.target.value as string

        this.setState({facilityReserveEditInfo: facilityReserveEditInfo},
            () => {
                this.updateTimeModel()
            })
        this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
    }

    onChangeDurationEndDateMinute(event: SelectChangeEvent<unknown>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.endTimeMinute = event.target.value as string

        this.setState({facilityReserveEditInfo: facilityReserveEditInfo},
            () => {
                this.updateTimeModel()
            })
        this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
    }

    onChangeStayCount(event: SelectChangeEvent<unknown>): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.stayCount = event.target.value as string

        const endDate = new Date(facilityReserveEditInfo.startDate)
        endDate.setDate(endDate.getDate() + Number(facilityReserveEditInfo.stayCount))
        facilityReserveEditInfo.endDate = formatForDateInput(endDate.toString())

        this.setState({facilityReserveEditInfo: facilityReserveEditInfo},
            () => {
                this.updateStayModel()
            })
        this.props.onChangeFacilityReserveInfo(facilityReserveEditInfo)
    }

    handleOpenResidentUserSelectionDialog(): void {
        this.setState({
            dialogOpenSelectResidentUser: true,
        })
    }

    closeSelectResidentUserDiaLog(): void {
        this.setState({dialogOpenSelectResidentUser: false})
    }

    getPaymentMethodList(): OptionProps[] {
        let paymentTypes: OptionProps[]

        paymentTypes = PAYMENT_TYPE.values()
            .filter((paymentType) => paymentType !== PAYMENT_TYPE.SERVICE_TRANSFER_ACCOUNT)
            .map((paymentType) => {
                return ({
                    label: `${paymentType.label}`,
                    value: `${paymentType.value}`,
                })
            })

        return paymentTypes
    }

    getCashPaymentStatusRadioGroupData(): PPRadioItemProp[] {
        const {facilityReserveEditInfo} = this.props

        let defaultCashPaymentStatus: string = CASH_PAYMENT_STATUS.YET_PAID.value
        if (facilityReserveEditInfo.cashPaymentStatus) {
            defaultCashPaymentStatus = facilityReserveEditInfo.cashPaymentStatus
        }

        const cashPaymentStatusData: PPRadioItemProp[] = []
        CASH_PAYMENT_STATUS.values().map((cashPaymentStatus) => (
            cashPaymentStatusData.push(
                {
                    label: cashPaymentStatus.label,
                    value: cashPaymentStatus.value,
                    radioProps: {
                        checked: cashPaymentStatus.value === defaultCashPaymentStatus,
                        onChange: this.onChangeCashPaymentStatus,
                    },
                },
            )
        ))
        return cashPaymentStatusData
    }

    async setSelectedResidentUserInfo(selectedResidentUserInfo: SelectedUserList[]): Promise<void> {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.selectedUserList = selectedResidentUserInfo
        this.setState({
            facilityReserveEditInfo: facilityReserveEditInfo,
            dialogOpenSelectResidentUser: false,
        }, () => {
            this.updateSelectedUserList()
        })
    }

    delSelectedUserInfo(selectedUser: SelectedUserList): void {
        const facilityReserveEditInfo = this.state.facilityReserveEditInfo
        facilityReserveEditInfo.selectedUserList = facilityReserveEditInfo.selectedUserList.filter(user => {
            return user.ridgeCd !== selectedUser.ridgeCd || user.roomNumber !== selectedUser.roomNumber
        })
        this.setState({facilityReserveEditInfo: facilityReserveEditInfo})
    }

    renderReserveDataInputOvernightFacility(overnightFacilitySetting: number): ReactNode {
        const {facilityReserveEditInfo} = this.state
        const {holidays} = this.props

        const stayCount: OptionProps[] = []
        for (let i: number = 1; i <= overnightFacilitySetting; i++) {
            stayCount.push({
                label: String(i),
                value: String(i),
            })
        }

        return (
            <>
                <TableRow>
                    <TableRowName>チェックイン～<br/>チェックアウト日時</TableRowName>
                    <TableCell colSpan={5}>
                        {facilityReserveEditInfo.startDate + ' '}
                        {facilityReserveEditInfo.startTimeHour}:{facilityReserveEditInfo.startTimeMinute}
                        {' ～ '}
                        {facilityReserveEditInfo.endDate + ' '}
                        {facilityReserveEditInfo.endTimeHour}:{facilityReserveEditInfo.endTimeMinute}
                    </TableCell>

                </TableRow>
                <TableRow>
                    <TableRowName required style={{paddingBottom: 4.5, paddingTop: 7.7}}>宿泊開始日</TableRowName>
                    <TableCell colSpan={2}>
                        <LeftRowFlexContainer>
                            <TermOvernightWrapper>
                                <PPDatePicker
                                    onChangeDate={this.onChangeOvernightStartDate}
                                    value={(facilityReserveEditInfo.startDate !== '') ?
                                        new Date(facilityReserveEditInfo.startDate) : null
                                    }
                                    minDate={(facilityReserveEditInfo.startMinDate !== '') ?
                                        new Date(facilityReserveEditInfo.startMinDate) : null
                                    }
                                    maxDate={(facilityReserveEditInfo.startMaxDate !== '') ?
                                        new Date(facilityReserveEditInfo.startMaxDate) : null
                                    }
                                    holidays={holidays}
                                    eventEmitter={this.props.eventEmitter}
                                    eventKeys={['reserveStartDate']}
                                />
                            </TermOvernightWrapper>
                        </LeftRowFlexContainer>
                    </TableCell>
                    <TableRowName required>泊数</TableRowName>
                    <TableCell colSpan={2}>
                        <PPSelect
                            eventEmitter={this.props.eventEmitter}
                            data={stayCount}
                            onChange={this.onChangeStayCount}
                            value={facilityReserveEditInfo.stayCount}
                            eventKeys={['stayCount']}
                        />
                    </TableCell>
                </TableRow>

            </>
        )
    }

    renderReserveDataInputDurationFacility(): ReactNode {
        const {facilityReserveEditInfo} = this.state
        const {holidays} = this.props

        return (
            <>
                <TableRow>
                    <TableRowName required>利用日</TableRowName>
                    <PublishPeriodTableCell colSpan={5}>
                        <TermFlexContainer>
                            <TermWrapper>
                                <FlexBasis>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeDurationStartDate}
                                        value={(facilityReserveEditInfo.startDate !== '') ?
                                            new Date(facilityReserveEditInfo.startDate) : null
                                        }
                                        minDate={(facilityReserveEditInfo.startMinDate !== '') ?
                                            new Date(facilityReserveEditInfo.startMinDate) : null
                                        }
                                        maxDate={(facilityReserveEditInfo.startMinDate !== '') ?
                                            new Date(facilityReserveEditInfo.startMaxDate) : null
                                        }
                                        holidays={holidays}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['reserveStartDatetime']}
                                    />
                                </FlexBasis>
                                <TimeFlexContainer>
                                    <PPSelect
                                        data={HOURS.values()}
                                        onChange={this.onChangeDurationStartDateHour}
                                        eventKeys={['reserveStartHour']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={String(Number(facilityReserveEditInfo.startTimeHour))}
                                    />
                                    <div>：</div>
                                    <PPSelect
                                        data={RESERVATION_TIME_UNIT_MINUTES.values()}
                                        onChange={this.onChangeDurationStartDateMinute}
                                        eventKeys={['reserveStartMinute']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={String(Number(facilityReserveEditInfo.startTimeMinute))}
                                    />
                                    <TermTxt>～</TermTxt>
                                </TimeFlexContainer>
                            </TermWrapper>
                            <TermWrapper>
                                <FlexBasis>
                                    <PPDatePicker
                                        onChangeDate={this.onChangeDurationEndDate}
                                        value={(facilityReserveEditInfo.endDate !== '') ?
                                            new Date(facilityReserveEditInfo.endDate) : null
                                        }
                                        minDate={(facilityReserveEditInfo.endMinDate !== '') ?
                                            new Date(facilityReserveEditInfo.endMinDate) : null
                                        }
                                        maxDate={(facilityReserveEditInfo.endMaxDate !== '') ?
                                            new Date(facilityReserveEditInfo.endMaxDate) : null
                                        }
                                        holidays={holidays}
                                        eventEmitter={this.props.eventEmitter}
                                        eventKeys={['reserveEndDatetime', 'endDate']}
                                    />
                                </FlexBasis>
                                <TimeFlexContainer>
                                    <PPSelect
                                        data={HOURS.values()}
                                        onChange={this.onChangeDurationEndDateHour}
                                        eventKeys={['reserveEndHour']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={String(Number(facilityReserveEditInfo.endTimeHour))}
                                    />
                                    <div>：</div>
                                    <PPSelect
                                        data={RESERVATION_TIME_UNIT_MINUTES.values()}
                                        onChange={this.onChangeDurationEndDateMinute}
                                        eventKeys={['reserveEndMinute']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={String(Number(facilityReserveEditInfo.endTimeMinute))}
                                    />
                                </TimeFlexContainer>
                            </TermWrapper>
                        </TermFlexContainer>
                    </PublishPeriodTableCell>
                </TableRow>
            </>
        )
    }


    renderOptionFormTable(): Nullable<ReactNode> {
        const {facilityData, RoomToResidentRepo, RidgeRepo} = this.props
        const {facilityReserveEditInfo, dialogOpenSelectResidentUser} = this.state
        let showSharedUseRoomNumberForm: boolean
        if (facilityData.accessControlManager === null) {
            showSharedUseRoomNumberForm = false
        } else {
            if (facilityData.accessControlManager === ACCESS_CONTROL_MANAGER.RIKB) {
                showSharedUseRoomNumberForm = facilityReserveEditInfo.facilityReserveCategory ===
                    FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value
            } else {
                showSharedUseRoomNumberForm = true
            }
        }

        return (
            <>
                <ConditionTableFixed>
                    <colgroup>
                        <col width={'15%'}/>
                        <col width={'15%'}/>
                        <col width={'10%'}/>
                        <col width={'15%'}/>
                        <col width={'10%'}/>
                        <col width={'10%'}/>
                    </colgroup>
                    <StyledTableCaption>予約情報</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>施設名</TableRowName>
                            <TableCell colSpan={5}>
                                {facilityData.facilityName}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>予約種別</TableRowName>
                            <TableCell colSpan={2}>
                                {RESERVATION_TYPE.codeToEnumConstants(facilityReserveEditInfo.reserveType).label}
                            </TableCell>
                            <TableRowName>予約ステータス</TableRowName>
                            <TableCell colSpan={2}>
                                {RESERVATION_STATUS.codeToEnumConstants(facilityReserveEditInfo.reserveStatus).label}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>施設予約区分</TableRowName>
                            <TableCell colSpan={5}>
                                {FACILITY_RESERVATION_CLASSIFICATION.codeToEnumConstants(
                                    facilityReserveEditInfo.facilityReserveCategory).label}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>予約タイトル</TableRowName>
                            <TableCell colSpan={5}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 30,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    value={facilityReserveEditInfo.reserveTitle}
                                    onChange={this.onChangeReserveTitle}
                                    eventKeys={['reserveTitle']}
                                    eventEmitter={this.props.eventEmitter}
                                    autoFocus
                                />
                                {
                                    facilityReserveEditInfo.facilityReserveCategory ===
                                    FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value &&
                                    <div>{Messages.IFACA0039.toString()}</div>
                                }
                            </TableCell>
                        </TableRow>

                        {facilityData.stayAvailability !== null &&
                        facilityData.stayAvailability
                            ? facilityData.overnightFacilitySetting &&
                            this.renderReserveDataInputOvernightFacility(
                                facilityData.overnightFacilitySetting.stayPossibleDateCount) :
                            this.renderReserveDataInputDurationFacility()
                        }

                        {showSharedUseRoomNumberForm &&
                            <>
                                <TableRow>
                                    <TableRowName
                                        rowSpan={facilityReserveEditInfo.selectedUserList.length + 1}>同時入室番号
                                    </TableRowName>
                                    <TableCell colSpan={5}>
                                        <RowFlexContainer>
                                            <SelectedFlexWrapper>
                                                <PPErrorDisplayButton
                                                    component={'span'}
                                                    size={'small'}
                                                    eventEmitter={this.props.eventEmitter}
                                                    eventKeys={['cardKeyNumbers']}
                                                    onClick={this.handleOpenResidentUserSelectionDialog}
                                                    clearError={true}
                                                    disabled={facilityReserveEditInfo.selectedUserList.length >=
                                                        HKConstants.CMN.OPC.MAX_SELECTABLE_SHARED_USE_ROOM_NUMBERS}
                                                >
                                                    追加する
                                                </PPErrorDisplayButton>
                                                <span style={{width: '80%'}}>
                                            {Messages.IFACC0005.toString(
                                                HKConstants.CMN.OPC.MAX_SELECTABLE_SHARED_USE_ROOM_NUMBERS,
                                            )}
                                        </span>
                                            </SelectedFlexWrapper>
                                        </RowFlexContainer>
                                    </TableCell>
                                </TableRow>
                            </>
                        }
                        {dialogOpenSelectResidentUser &&
                            <NatResidentUserSelectionComponent
                                roomToResidentRepo={RoomToResidentRepo}
                                ridgeRepo={RidgeRepo}
                                selectUserType={SELECT_USER_TYPE.ROOM_NUMBER.value}
                                mainUserFlag={true}
                                cardKeyNumberIsNotNullFlg=
                                    {facilityData.accessControlManager === ACCESS_CONTROL_MANAGER.ODEC_TECHNO}
                                closeSelectResidentUserDiaLog={this.closeSelectResidentUserDiaLog}
                                setSelectedExclusionResidentUserInfo={this.setSelectedResidentUserInfo}
                                selectedCondominiumCd={this.state.selectedCondominiumCd}
                                invalidUserSelectFlag={true}
                                eventEmitter={this.props.eventEmitter}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                                maxSelectableKeyNumber={HKConstants.CMN.OPC.MAX_SELECTABLE_SHARED_USE_ROOM_NUMBERS}
                                selectedUserList={this.state.facilityReserveEditInfo.selectedUserList}
                                excudeResidentUserInfo={this.props.excudeResidentUserInfo}
                                validPeriodCriteriaDate={moment(this.state.facilityReserveEditInfo.startDate)}
                            />
                        }
                        {
                            [...facilityReserveEditInfo.selectedUserList].sort((a, b) => {
                                const aName = `${a.ridgeCd}${a.roomNumber}`
                                const bName = `${b.ridgeCd}${b.roomNumber}`
                                if (aName === bName) {
                                    return 0
                                }
                                return (aName > bName) ? 1 : -1
                            }).map((ridgeInfo, index) => (
                                <TableRow key={index}>
                                    <TableCell colSpan={5}>
                                        <LeftRowFlexContainer>
                                            <RidgeWrapper>
                                                <TableCellLabelNoLeftPadding>
                                                    {ridgeInfo.ridgeName} {ridgeInfo.roomNumber}
                                                </TableCellLabelNoLeftPadding>
                                            </RidgeWrapper>
                                            <RidgeWrapper>
                                                <DeleteRidgeLink>
                                                    <DeleteLink onClick={(event: React.MouseEvent) => {
                                                        event.preventDefault()
                                                        this.delSelectedUserInfo(ridgeInfo)
                                                    }}>
                                                        削除
                                                    </DeleteLink>
                                                </DeleteRidgeLink>
                                            </RidgeWrapper>
                                        </LeftRowFlexContainer>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                        {facilityReserveEditInfo.facilityReserveCategory !==
                            FACILITY_RESERVATION_CLASSIFICATION.ADMIN.value &&
                            <>
                                <TableRow>
                                    <TableRowName required>支払方法</TableRowName>
                                    <TableCell
                                        colSpan={(facilityReserveEditInfo.facilityPaymentMethod ===
                                            PAYMENT_TYPE.CASH.value) ? 2 : 5}>
                                        <PPSelect
                                            data={this.getPaymentMethodList()}
                                            onChange={this.onChangePaymentMethod}
                                            eventKeys={['paymentMethod']}
                                            eventEmitter={this.props.eventEmitter}
                                            value={facilityReserveEditInfo.facilityPaymentMethod}
                                        />
                                    </TableCell>
                                    {facilityReserveEditInfo.facilityPaymentMethod === PAYMENT_TYPE.CASH.value &&
                                        <>
                                            <TableRowName required>現金支払ステータス</TableRowName>
                                            <TableCell colSpan={2}>
                                                <PPRadioGroup
                                                    row
                                                    data={this.getCashPaymentStatusRadioGroupData()}
                                                    eventKeys={['cashPaymentStatus']}
                                                    eventEmitter={this.props.eventEmitter}
                                                />
                                            </TableCell>
                                        </>
                                    }
                                </TableRow>
                            </>
                        }
                    </TableBody>
                </ConditionTableFixed>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        return (
            <>
                {this.renderOptionFormTable()}
            </>
        )
    }
}

export default NatAdminFacilityReserveInfoComponent

const SelectedFlexWrapper = styled.div`
  display: flex;
  padding-right: 15px;
  flex: 1 1 0%;
  align-items: center;
`
const RidgeWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
  padding-right: 15px;
`

const TableCellLabelNoLeftPadding: StyledLabel = styled.label`
  padding: 0 10px 0 0;
`

const DeleteRidgeLink = styled.div`
  margin-right: 60px;
`

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-items: center;
  align-items: center;
  max-width: 35%;
`

const TermOvernightWrapper = styled(TermWrapper)`
  max-width: 55%;
`

const PublishPeriodTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    white-space: nowrap;
  }
`

const TermFlexContainer: StyledDiv = styled.div`
  display: flex;
  align-items: center;
`

const TimeFlexContainer = styled(TermFlexContainer)`
  padding-bottom: 4px;
  padding-left: 15px;
  flex: 1 0 0%

`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`
